import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { FormattedMessage } from "react-intl";
import img1 from "../../assets/images/billbee/img1.png";
import img2 from "../../assets/images/billbee/img2.png";

const pStyle = {
  fontSize: "18px",
  marginBottom: "16px"
};

export default function BillbeeGuide() {
  return (
    <Box>
      <Typography component="p" sx={pStyle} className="text">
        <FormattedMessage
          id="billbee.step1"
          values={{
            b: (...chunks) => {
              return <b style={{ fontWeight: "500" }}>{chunks}</b>;
            },
            br: <br />
          }}
        />
      </Typography>
      <img alt="Billbee Step 1" src={img1} style={{ width: "100%" }} />
      <br />
      <br />
      <Typography component="p" sx={pStyle} className="text">
        <FormattedMessage
          id="billbee.step2"
          values={{
            b: (...chunks) => {
              return <b style={{ fontWeight: "500" }}>{chunks}</b>;
            },
            br: <br />
          }}
        />
      </Typography>
      <img alt="Billbee Step 2" src={img2} style={{ width: "100%" }} />
      <br />
      <br />
      <Typography component="p" sx={pStyle} className="text">
        <FormattedMessage
          id="billbee.step3"
          values={{
            b: (...chunks) => {
              return <b style={{ fontWeight: "500" }}>{chunks}</b>;
            },
            br: <br />
          }}
        />
      </Typography>{" "}
    </Box>
  );
}
